import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Recta/updateRecta`, method: 'POST', body: values, token: token})
}
